import { render, staticRenderFns } from "./Adware.vue?vue&type=template&id=11cf975e"
import script from "./Adware.vue?vue&type=script&lang=js"
export * from "./Adware.vue?vue&type=script&lang=js"
import style0 from "./Adware.vue?vue&type=style&index=0&id=11cf975e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports